import React from 'react';
import NextHead from 'next/head';

export interface HeadProps {
  title?: string;
  description?: string;
  image?: string;
}

export const Head = (props: HeadProps) => {
  const title = props.title || 'ShareMint - The Web3 Affiliate Network';
  const description = (
    props.description || 'Launch a web3 affiliate program in minutes and reach 1M+ web3 users.'
  ).substring(0, 200);
  const image = props.image || 'https://sharemint.xyz/images/og.png';

  // `key` is used to help with duplicates: https://nextjs.org/docs/api-reference/next/head

  return (
    <NextHead>
      <title key="title">{title}</title>
      <meta name="description" key="description" content={description} />
      <meta property="og:title" key="og:title" content={title} />
      <meta property="og:description" key="og:description" content={description} />
      <meta property="og:type" key="og:type" content="website" />
      <meta property="og:image" key="og:image" content={image} />
      <meta name="twitter:title" key="twitter:title" content={title} />
      <meta name="twitter:description" key="twitter:description" content={description} />
      <meta name="twitter:image" key="twitter:image" content={image} />
      <link rel="icon" href="/favicon.ico" />
    </NextHead>
  );
};
